/* eslint-disable no-loop-func */
import _ from 'lodash';
import $ from 'jquery';
import React, { PureComponent } from 'react';
import { Dialog, FormGroup, Select, Input } from '@tencent/spaui';
import { SelectTree } from '@tencent/spaui-business';
import { IndustryDetail, logic } from '@/components/IndustryDetail/index';
import industryUtil from '@/utils/industry';
import { connect } from 'react-redux';
import { withApi } from '@tencent/react-aio';
import Cgi from '@/api/operator/cgi/smb/account/gdt';
import { hasFeatureFlag } from '@/services';

const fieldNames = {
  labelFieldName: 'name',
  nodeFieldName: 'children',
  valueFieldName: 'id',
};

const requiredFieldMap = {
  industry_id: { tip: '请选择所属行业', errField: 'industryIdErr' },
  industry_product_name: { tip: '请选择产品名称', errField: 'industryProductNameErr' },
  industry_product_name_other: { tip: '请填写产品名称', errField: 'industryProductNameOtherErr' },
};

const requiredFieldMapByGDT = {
  industry_id: { tip: '请选择所属行业', errField: 'industryIdErr' },
  industry_product_name: { tip: '请选择产品名称', errField: 'industryProductNameErr' },
  industry_product_name_other: { tip: '请填写产品名称', errField: 'industryProductNameOtherErr' },
};

const requiredFieldMapByWeChat = {};

class IndustryInfo extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      agency_uid: this.props.agencyUid || '',
      // 提交跟显示的数据
      formData: {
        qualification_coded: '',
        qualification: '',
      },
      industryInfo: {},
      checkedSubIndustries: [],
      otherQualifications: [],
      industryList: [],
      // { [industry_id]: productNameList }
      industryProductsMap: {},
      tips: {
        show: false,
        type: '',
        msg: '',
      },
      confirmTip: {
        show: false,
        title: '',
        msg: '',
      },
      deleteQualification: {},
      isFirst: true,

      // Error
      industryIdErr: '',
      industryProductNameErr: '',
      industryProductNameOtherErr: '',
      showQualError: false,
    };

    this.hasAddtionalCheck = false;
    this.onChangeIndustry = this.onChangeIndustry.bind(this);
    this.canSelected = this.canSelected.bind(this);
    this.hasAddtionalCheck = false;
    this.onAddQualification = this.onAddQualification.bind(this);
    this.onDeleteQualification = this.onDeleteQualification.bind(this);
    this.onCheckHasAddtionalCheck = this.onCheckHasAddtionalCheck.bind(this);
    this.onUploaderFileChange = this.onUploaderFileChange.bind(this);
    this.onDeleteFileConfirm = this.onDeleteFileConfirm.bind(this);
    this.onChangeOptionalQualficationChosenVal = this.onChangeOptionalQualficationChosenVal.bind(this);
    this.onChangeCheckedSubIndustries = this.onChangeCheckedSubIndustries.bind(this);
    this.onChangeMultiple = this.onChangeMultiple.bind(this);
    this.failedCb = this.failedCb.bind(this);
    this.handleTipClose = this.handleTipClose.bind(this);
    this.handleConfirmClose = this.handleConfirmClose.bind(this);
    this.handleConfirmSubmit = this.handleConfirmSubmit.bind(this);
  }

  componentDidMount() {
    this.props.onRef(this);

    // 获取广告行业产品名称列表
    Cgi.getIndustryProductNameList().then((res = {}) => {
      if (res.ret == 0) {
        if (res.data && res.data.list) {
          const industryProductsMap = _.reduce(res.data.list, (result, cur) => {
            result[cur.industry_id] = cur;
            return result;
          }, {});

          this.setState({
            industryProductsMap,
          });
        }
      }
    });
  }

  // 设置formData
  setFormData(params) {
    let formData = $.extend(true, this.state.formData, params);

    if (params.qualification_coded) {
      delete formData.qualification_coded;
      formData.qualification_coded = params.qualification_coded;
    } else if (params.qualification) {
      delete formData.qualification;
      formData.qualification = params.qualification;
    }

    this.setState({
      formData,
    });
  }

  /**
   * 改变行业的回调
   *
   * @param      {number}   data                  The data
   * @param      {boolean}  isNeedSecondIndustry  Indicates if need second industry
   * @param      {boolean}  isInit                Indicates if initialize
   */
  onChangeIndustry(data, certifications, isInit = false, initCheckedData = []) {
    let industry_id = data;
    let subIndustryId;
    let subIndustryQualis;
    let additional_infos;

    const qualification_coded = this.state.formData.qualification_coded || [];
    const qualification_coded_formatted = {};
    const checkedSubIndustries = [];
    const industryInfo = $.extend(true, {}, this.state.industryInfo);

    let industryData; let item; let _image_id; let _image_url; let _name; let _code; let _industry_id; let qualification_coded_formatted_item; let randomNum; let i; let j;

    let businessRange = [];
    let businessRangeId;
    let businessRangeCtfGrp = [];

    const handleChange = (data) => {
      industryData = data;

      // 处理业务范围数据，去除不需要的字段，记录需要check的项
      businessRange = industryData.business_range;
      let ctfWithImg;

      for (i in businessRange) {
        let checked = [];
        businessRangeId = businessRange[i].business_range_id;
        initCheckedData
          && initCheckedData.length > 0
          && initCheckedData.forEach((item) => {
            if (item.business_range_id === businessRangeId) {
              checked.push(item);
            }
          });
        businessRangeCtfGrp = businessRange[i].certification_group;
        for (j in businessRangeCtfGrp) {
          if (initCheckedData && initCheckedData.length > 0) {
            ctfWithImg = logic.formatCertificationDataByInit(businessRangeCtfGrp[j], checked);
          } else {
            ctfWithImg = logic.formatCertificationData(businessRangeCtfGrp[j]);
          }

          businessRangeCtfGrp[j] = ctfWithImg.data;
          // 如果该业务范围下的某个资质不为空，且不为补充资质，则选中这个业务范围
          if (!ctfWithImg.isEmpty && !logic.isAdditional(businessRangeId.toString())) {
            if (checkedSubIndustries.indexOf(businessRangeId.toString()) === -1) {
              checkedSubIndustries.push(businessRangeId.toString());
            }
            continue;
          }
        }
      }

      for (i in industryData.certification_group) {
        let checked = [];
        initCheckedData
          && initCheckedData.length > 0
          && initCheckedData.forEach((item) => {
            if (item.business_range_id === 0) {
              // business_range_id === 0 为资质证件
              // business_range_id === -2147483868232 为业务范围
              checked.push(item);
            }
          });
        if (initCheckedData && initCheckedData.length > 0) {
          ctfWithImg = logic.formatCertificationDataByInit(industryData.certification_group[i], checked);
        } else {
          ctfWithImg = logic.formatCertificationData(industryData.certification_group[i]);
        }
        industryData.certification_group[i] = ctfWithImg.data;
      }

      let newState = {};

      if (checkedSubIndustries.length > 0) {
        newState = $.extend(true, newState, { checkedSubIndustries });
      }

      industryInfo[industry_id] = industryData;

      let formData_qualification_coded = [];

      let otherQualifications = industryUtil.formatDeprecQualification(industryData.other_certifications);

      // 保存最初的编码资质信息，便于对比
      if (isInit) {
        // 把编码资质抽出来
        logic.getQualificationCoded(industryData, industry_id, formData_qualification_coded, checkedSubIndustries, this.hasAddtionalCheck);
      }

      this.props.onChange('industryInfo', { ...this.props.value, industry_certifications_list: industryInfo });
      this.setState({
        ...newState,
        industryInfo,
        otherQualifications,
      });

      this.setFormData({
        qualification_coded: formData_qualification_coded,
      });

      this.inputValidate(industry_id, 'industry_id');
    };

    if (!certifications) {
      const { webApi } = this.props;
      // 获取行业资质
      webApi
        .getIndustryInfo(industry_id)
        .ajax()
        .then(
          (result = {}) => {
            industryData = JSON.parse(result);
            handleChange(industryData);
          },
          () => {
            this.setState({
              tips: {
                show: true,
                type: 'warn',
                msg: '网络错误',
              },
            });
          },
        );

      this.props.onChange('industryInfo', { ...this.props.value, industry_id, industry_product_name: '', industry_product_name_other: '' });
    } else {
      handleChange(certifications);
    }
  }

  /**
   * 向industryInfo 添加资质
   *
   * @param      {objecy}   data    图片数据，包含code file industry_id name url
   * @param      {boolean}  isFake  需不需要把图片添加到industryInfo
   */
  onAddQualification(data) {
    const industryInfo = this.state.industryInfo || {};
    const newIndustryInfo = _.cloneDeep(industryInfo);

    if (data.name && data.industry_id && data.code) {
      newIndustryInfo[this.props.value.industry_id] = logic.addImgToIndustryData(newIndustryInfo[this.props.value.industry_id], data);
      this.setState({
        industryInfo: newIndustryInfo,
      });

      this.props.onChange('industryInfo', { ...this.props.value, industry_certifications_list: newIndustryInfo });
    }
  }

  /**
   * 从industryInfo & formData 中删除资质
   *
   * @param      {object}   data    图片数据， 包含 industry_id code name
   * @param      {boolean}  isFake  需不需要把图片从industryInfo中删除
   */
  onDeleteQualification(data) {
    const industryInfo = this.state.industryInfo || {};
    const fileDOM = $(`#${data.name}`)[0];

    if (data.name && data.industry_id && data.code) {
      industryInfo[this.props.value.industry_id] = logic.deleteImgFromIndustryData(industryInfo[this.props.value.industry_id], data);

      this.setState({
        industryInfo,
      });

      this.props.onChange('industryInfo', { ...this.props.value, industry_certifications_list: industryInfo });
    }
  }

  /**
   * 勾选还有其他资质
   */
  onCheckHasAddtionalCheck(hasAddtionalCheck) {
    this.hasAddtionalCheck = hasAddtionalCheck;
  }

  onChangeCheckedSubIndustries(checkedSubIndustries) {
    this.setState({
      checkedSubIndustries,
    });
  }

  /**
   * 上传资质图片的回调
   * @param {*} event
   * @param {*} code
   * @param {*} qualiData
   * @param {*} industry_id
   */
  onUploaderFileChange(event, code, qualiData, industry_id, certificationId = '') {
    const target = event.target;
    const regex = /(.jpg|.jpeg|.png)$/;
    const reader = new FileReader();
    const type = event.type;
    const that = this;
    const qualiType = qualiData.type;
    const agency_uid = this.state.agency_uid;

    let inputId;
    let files;
    let fileLength = '';

    if (type === 'dragenter' || type === 'dragover' || type === 'drop') {
      event.preventDefault();
    }

    if (type === 'change' || type === 'drop') {
      if (type === 'change') {
        files = target.files;
        inputId = target.id;
      } else {
        files = event.dataTransfer.files;
        inputId = $(target).parents('.picWrapper')
          .find('label')
          .prop('for');
      }

      fileLength = files.length;
      reader.onload = (e) => {
        // without uid
        if (type === 'drop') {
          this.onAddQualification({
            file: inputId,
            fileData: files,
            industry_id,
            code,
            name: inputId,
            url: e.target.result,
          });
        } else {
          if (qualiType === 'range') {
            this.onAddQualification({
              file: inputId,
              industry_id,
              code,
              name: inputId,
              url: e.target.result,
            });
          } else {
            this.onAddQualification({
              file: inputId,
              industry_id,
              code,
              name: inputId,
              url: e.target.result,
            });
          }
        }
      };

      if (files[0] && files[0].name && regex.test(files[0].name.toLowerCase())) {
        if (files[0].size < 1024 * 1024 * 5) {
          // with agency_uid
          // 上传图片，获取image_id
          let _files = [];
          _files.push(files[0]);

          industryUtil.uploadImgWithUidByFileapiPromise(_files, this.state.agency_uid).then(
            (img) => {
              // 命中灰度标签，不传image_id
              if (hasFeatureFlag('drop_img_upload_image_id')) {
                this.onAddQualification({
                  industry_id,
                  code,
                  // image_id: img.file_id,
                  name: inputId,
                  url: img.file_url,
                });
                return;
              }

              this.onAddQualification({
                industry_id,
                code,
                image_id: img.file_id,
                name: inputId,
                url: img.file_url,
              });
            },
            (err) => {
              this.failedCb(err);
            },
          );
        } else {
          that.setState({
            tips: {
              type: 'warn',
              msg: '上传失败: 文件大小不能超过5120KB',
              show: true,
            },
          });
          target.value = '';
        }
      } else {
        if (files[0] && files[0].name) {
          that.setState({
            tips: {
              type: 'warn',
              msg: '上传失败: 该文件格式不符合要求',
              show: true,
            },
          });
          target.value = '';
        }
      }
    }
  }

  /**
   * 改变选择一种资质上传的选项
   */
  onChangeOptionalQualficationChosenVal(event, val, data, industry_id) {
    // 隐藏其他可选资质的上传模块
    const industryInfo = this.state.industryInfo || {};
    const newIndustryInfo = _.cloneDeep(industryInfo);

    // 设置对应optinal资质的code_checked字段
    newIndustryInfo[this.props.value.industry_id] = logic.setOptionalCodeChecked(newIndustryInfo[this.props.value.industry_id], industry_id, val);

    this.setState({
      industryInfo: newIndustryInfo,
    });

    this.props.onChange('industryInfo', { ...this.props.value, industry_certifications_list: newIndustryInfo });
  }

  onDeleteFileConfirm(name, code, industry_id) {
    this.setState({
      confirmTip: {
        show: true,
        title: '确认删除',
        msg: '你确认要删除该资质吗？',
      },
      deleteQualification: {
        industry_id,
        code,
        name,
      },
    });
  }

  handleConfirmClose() {
    this.setState({
      confirmTip: {
        show: false,
        title: '',
        msg: '',
      },
      deleteQualification: {},
    });
  }

  handleConfirmSubmit() {
    this.setState({
      confirmTip: {
        show: false,
        title: '',
        msg: '',
      },
    });
    this.onDeleteQualification(this.state.deleteQualification);
  }

  /**
   * 是否勾选资质控件多页选项
   */
  onChangeMultiple(industryId, code, certificationId, checked) {
    const id = this.props.value.industry_id;
    const changedCertfication = logic.findCertification(this.state.industryInfo[id], industryId, code);

    for (const i in changedCertfication.images) {
      // eslint-disable-next-line eqeqeq
      if (changedCertfication.images[i].id == certificationId) {
        // 当照片数量大于2时，不允许取消勾选
        if ((!checked && changedCertfication.images[i].data.length < 2) || checked) {
          changedCertfication.images[i].multiple = checked;
        } else {
          this.setState({
            tips: {
              type: 'warn',
              msg: '如需取消多页，请只保留一页资质',
              show: true,
            },
          });
        }
      }
    }

    this.setState({
      industryInfo: $.extend(true, {}, this.state.industryInfo),
    });
  }

  canSelected(treeNode, defaultAllowSelected) {
    if (treeNode.deepLevel === 1) {
      return false;
    }
    if (treeNode.isdisabled === 'active' || treeNode.isdisabled === 'pre_deprecated') {
      return true;
    } if (treeNode.isdisabled === 'deprecated') {
      return false;
    }
  }

  approvalStatusDisableEdit(status) {
    if (status === 1) {
      return true;
    }

    return false;
  }

  /*
   * 用于上传失败提示
   */
  failedCb(result) {
    let msg = '';
    if (typeof result === 'string') {
      msg = result;
    } else if (result instanceof Array) {
      // 传入的result是一个数组
      const msgArr = result.map((item) => {
        // return item.name + item.msg;    // 提示上传失败的文件名及对应的失败信息
        return item.msg || '';
      });
      msg = msgArr.join(' ');
    } else {
      // 传入的result是一个对象
      msg = result.msg || '';
    }

    this.setState({
      tips: {
        type: 'warn',
        show: true,
        msg: `上传失败: ${msg}` || '',
      },
    });
  }

  handleTipClose(event) {
    this.setState({
      tips: {
        show: false,
        msg: '',
        type: '',
      },
    });
  }

  formateIndustryInfo(industryInfo = []) {
    let { checkedSubIndustries } = this.state;
    let { industry_id } = this.props.value;
    let qualification_coded = [];
    let qualification_coded_final = [];
    let i;
    let qual;
    const data = industryInfo[industry_id] ? industryInfo[industry_id] : industryInfo;

    // 从industryData中取出有图片的资质，放在  qualification_coded 里
    logic.getQualificationCoded(data, industry_id, qualification_coded, checkedSubIndustries, this.hasAddtionalCheck);

    let imgs = [];

    // 修改下编码资质格式
    for (i in qualification_coded) {
      qual = qualification_coded[i];
      imgs = [];

      for (const j in qual.images) {
        if (qual.images[j].image_id) {
          imgs.push({
            image_id: qual.images[j].image_id,
            image_url: qual.images[j].image_url,
          });
        } else {
          if (hasFeatureFlag('drop_img_upload_image_id')) {
            imgs.push({
              image_id: qual.images[j].image_id,
              image_url: qual.images[j].image_url,
            });
          }
        }
      }
      qualification_coded_final.push({
        industry_id: qual.industry_id,
        business_range_id: qual.business_range_id,
        code: qual.code,
        images_list: imgs,
        certification_id: '',
      });
    }

    return qualification_coded_final;
  }

  validEachFieldIsEmpty = (type) => {
    let result = true;
    const { checkedSubIndustries, industryProductsMap } = this.state;
    const { industry_id, industry_certifications_list, industry_product_name } = this.props.value;
    const { container } = this.props;

    let map;
    const keys = [];
    // 【灰度】当前行业存在对应的产品名称信息。注意hasFeatureFlag第二个参数不传，默认即为按bmId灰度。
    if (hasFeatureFlag('is_display_industry_product_name')) {
      type = 'GDT';
    }
    if (type === 'GDT') {
      map = requiredFieldMapByGDT;
      keys.push('industry_id');

      // 有灰度标签，且在开户页内调用，追加行业名称必填校验
      if (hasFeatureFlag('is_display_industry_product_name') && (container === 'advertiser-add-account__page') && industryProductsMap[industry_id]) {
        keys.push('industry_product_name');
        // 当前产品名称为'其他'
        if (industry_product_name === '其他') {
          keys.push('industry_product_name_other');
        }
      }
    } else if ('WeChat') {
      map = requiredFieldMapByWeChat;
    }

    keys.forEach((key) => {
      const stateVal = this.props.value[key];
      const mapVal = map[key];
      const { tip, errField } = mapVal;

      if (!stateVal) {
        result = false;
        this.setState({
          [errField]: tip,
        });
      } else {
        this.setState({
          [errField]: '',
        });
      }
    });

    if (type === 'GDT') {
      // 检查资质是否缺少
      const checkQualification = logic.checkQualificationValidation(industry_certifications_list[industry_id], this.hasAddtionalCheck, checkedSubIndustries);

      if (!checkQualification) {
        result = false;
        this.setState({
          showQualError: true,
        });
      }
    }

    return result;
  }

  inputValidate = (value, field) => {
    const { tip, errField } = requiredFieldMap[field];
    if (value) {
      this.setState({
        [errField]: '',
      });
    } else {
      this.setState({
        [errField]: tip,
      });
    }
  }

  resetErrStatus = () => {
    this.setState({
      industryIdErr: '',
      industryProductNameErr: '',
      industryProductNameOtherErr: '',
      showQualError: false,
    });
  }

  render() {
    const state = this.state;
    const { tips, confirmTip, isFirst, industryList, industryIdErr, industryProductNameErr, industryProductNameOtherErr, industryProductsMap } = state;

    const { industry_id, industry_product_name, industry_product_name_other, industry_certifications_list } = this.props.value;
    const {
      type,
      hideTitle,
      // 调用容器标记
      container,
    } = this.props;

    if (industry_id && industryList.length > 0 && isFirst && type === 'edit') {
      this.onChangeIndustry(industry_id, industry_certifications_list, true);
      this.setState({
        isFirst: false,
      });
    }

    let industryDetailComp;
    if (state.industryInfo && state.industryInfo[industry_id] && state.industryInfo[industry_id].industry_id) {
      industryDetailComp = (
        <div>
          <IndustryDetail
            data={state.industryInfo[industry_id]}
            uid={state.uid}
            error={state.showQualError}
            otherQualifications={state.otherQualifications}
            checkedSubIndustries={state.checkedSubIndustries}
            onChangeCheckedSubIndustries={this.onChangeCheckedSubIndustries}
            onCheckHasAddtionalCheck={this.onCheckHasAddtionalCheck}
            failedCb={this.failedCb}
            onUploaderFileChange={this.onUploaderFileChange}
            onUploaderFileDelete={this.onDeleteFileConfirm}
            onChangeOptionalQualficationChosenVal={this.onChangeOptionalQualficationChosenVal}
            onChangeMultiple={this.onChangeMultiple}
            approvalStatusDisableEdit={this.approvalStatusDisableEdit}
            otherQualificationsConfig={{
              disabled: true,
            }}
          />
        </div>
      );
    } else {
      industryDetailComp = '';
    }
    // 当前行业对应的产品名称信息
    const productNamesInfo = industryProductsMap[industry_id];

    return (
      <div className="auto-lump" id="industryInfo">
        {!hideTitle
          && <h2 style={{ fontSize: '18px' }} className="auto-lump-hd">
            行业信息
          </h2>
        }
        <div className="auto-lump-bd">
          <ul className="auto-infos">
            <li className="auto-infolist">
              <span className="auto-info-tt">所属行业</span>
              <div className="auto-info-des">
                <FormGroup error={industryIdErr}>
                  <SelectTree
                    style={{ width: '520px' }}
                    fieldNames={fieldNames}
                    data={this.props.industryTree}
                    value={industry_id}
                    onChange={(event, value, treeNode, valueNodeMap) => this.onChangeIndustry(value)}
                    canSelected={this.canSelected}
                    setNodeClassName={(treeData) => {
                      if (treeData.isdisabled === 'deprecated') {
                        return 'spaui-disable-item';
                      }
                    }}
                    dropStyle={{
                      width: '520px',
                    }}
                  />
                </FormGroup>
              </div>
            </li>
            {/* 有灰度标签，且在开户页面中调用 */}
            {(hasFeatureFlag('is_display_industry_product_name') && (container === 'advertiser-add-account__page') && !!productNamesInfo) && (
              <>
                <li className="auto-infolist">
                  <span className="auto-info-tt">产品名称</span>
                  <div className="auto-info-des">
                    <FormGroup error={industryProductNameErr} style={{ minWidth: '520px' }}>
                      <Select
                        data={_.map(productNamesInfo?.product_name_list, (name) => ({ label: name, value: name }))}
                        value={industry_product_name}
                        onChange={(event, value) => {
                          this.props.onChange('industryInfo', { ...this.props.value, industry_product_name: value });
                          this.inputValidate(value, 'industry_product_name');
                        }}
                      />
                    </FormGroup>
                  </div>
                </li>
                {(industry_product_name === '其他') && (
                  <li className="auto-infolist">
                    <span className="auto-info-tt">其他</span>
                    <div className="auto-info-des">
                      <FormGroup error={industryProductNameOtherErr} style={{ minWidth: '520px' }}>
                        <Input
                          placeholder="请精准描述要投放的产品或服务，如：鲜花配送"
                          value={industry_product_name_other}
                          onChange={(event, value) => {
                            this.props.onChange('industryInfo', { ...this.props.value, industry_product_name_other: value });
                            this.inputValidate(value, 'industry_product_name_other');
                          }}
                        />
                      </FormGroup>
                    </div>
                  </li>
                )}
              </>
            )}
            {industryDetailComp}
          </ul>
        </div>
        {/** 提示组件 **/}
        <Dialog show={tips.show} time={2000} timeCallback={this.handleTipClose} type="tip" iconType={tips.type}>
          {tips.msg}
        </Dialog>
        {/** 确认提示组件 **/}
        <Dialog type="normal" className="spaui-dialog-confirm-normal" enabledBackdropClose title={confirmTip.title} show={confirmTip.show} onClose={this.handleConfirmClose} onSubmit={this.handleConfirmSubmit} onCancel={this.handleConfirmClose}>
          <div>{confirmTip.msg}</div>
        </Dialog>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    industryTree: _.isEmpty(state.industryCreate) ? [] : state.industryCreate,
  };
}

export default withApi(connect(mapStateToProps)(IndustryInfo));
